<template>
	<el-dialog title="阅读情况" :visible="true" width="50%" @close="$emit('close')">
		<el-form inline>
			<el-form-item label="">
				<el-input v-model="filter.keyword" @input="getSendee(1)" placeholder="请输入用户名">
				</el-input>
			</el-form-item>
			<el-form-item label="阅读情况：">
				<el-select v-model="filter.is_read" @change="getSendee(1)" placeholder="">
					<el-option label="全部" :value="null" />
					<el-option label="未读" :value="false" />
					<el-option label="已读" :value="true" />
				</el-select>
			</el-form-item>
		</el-form>
		<el-table height="520px" :data="list" border style="margin-bottom: 20px;" row-key="id"
			:tree-props="{children:'forwards'}" :row-class-name="tableRowClassName">
			<el-table-column label="阅读人">
				<template slot-scope="scope">
					{{scope.row.sendee.name}} {{scope.row.forwards.length>0?`(转发${scope.row.forwards.length}人)`:''}}
				</template>
			</el-table-column>
			<el-table-column align="center" label="阅读时间" prop="sendee.time">

			</el-table-column>
			<el-table-column align="center" label="操作" prop="sendee.time">
				<template slot-scope="scope">
					<el-button type="text" size="small" @click="remove(scope.row)">删除</el-button>
				</template>
			</el-table-column>
		</el-table>
		<el-pagination @current-change="getSendee" :current-page="filter.page" :page-size="filter.size"
			style="text-align:right;float:none" layout="total, prev, pager, next" :total="totalRow"></el-pagination>
	</el-dialog>
</template>

<script>
	import { oa_notice } from "@/api/education";
	export default {
		props: ['id', 'is_admin'],
		data() {
			return {
				list: [],
				totalRow: 0,
				totalPage: 0,
				filter: {
					id: this.id,
					size: 8,
					is_read: null,
					keyword: '',
					page: 1,
					is_admin: this.is_admin
				}

			}
		},
		methods: {
			tableRowClassName({ row }) {
				if (row.forwards.length > 0) {
					return 'hight-row'
				}
				return ''
			},
			getSendee(p) {
				this.list = []
				this.filter.page = p || this.filter.page
				oa_notice.getSendeePage(this.filter).then(res => {
					if (res.data) {
						this.list = res.data.list || []
						this.totalRow = res.data.totalRow
						this.totalPage = res.data.totalPage
						this.filter.page = res.data.page
					}
				})
			},
			remove(data) {

				const id = data.id.split("|")[0]

				this.$confirm('确定删除当前收件人吗？删除当前人员的同时也会删除其所有转发的内容', '提示')
					.then(_ => {
						this.removeNode(data.id, this.list)
						const promise = oa_notice.removeSendee({ id: id, user_id: data.sendee.user_id, user_type: data.sendee.user_type })
						if (this.list.length == 0) {
							promise.then(res=>{
								this.getSendee(this.filter.page-1)
							})
						}
						return promise
					}).then(res => {
						this.$message.success("删除成功")
					})
			},
			removeNode(id, list) {
				const index = list.findIndex(v => v.id == id)
				if (index > -1) {
					list.splice(index, 1)

				}
				list.forEach(e => {
					if (e.forwards.length > 0) {
						this.removeNode(id, e.forwards)
					}
				});
			}

		},
		mounted() {
			this.getSendee()
		},
	}
</script>

<style lang="scss" scoped>
	// .el-table /deep/th {
	// 	background-color: #ffffff;
	// 	color: #606266;
	// }
	.el-table /deep/.hight-row {
		background: oldlace;
	}
</style>


// WEBPACK FOOTER //
// src/views/notice/sendee-list.vue